import { render, staticRenderFns } from "./PhotoBlock.vue?vue&type=template&id=416c9e74&scoped=true"
import script from "./PhotoBlock.vue?vue&type=script&lang=js"
export * from "./PhotoBlock.vue?vue&type=script&lang=js"
import style0 from "./PhotoBlock.vue?vue&type=style&index=0&id=416c9e74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c9e74",
  null
  
)

export default component.exports